import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Lock, User, ArrowLeft } from "lucide-react";
import { useAuth } from "../lib/AuthContext";
import Logo from "../components/Logo";
import Seo from "../components/Seo";

export default function AdminLogin() {
  const { user, login, error } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (user && (user.role === "admin" || user.role === "referee")) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const ok = await login(username, password);
    setSubmitting(false);
    if (ok) navigate("/admin", { replace: true });
  };

  return (
    <div className="min-h-screen bg-green-950 relative flex items-center justify-center px-5 py-12" data-testid="admin-login-page">
      <Seo title="Prihlásenie" noindex />
      <div className="absolute inset-0 pitch-grid opacity-30 pointer-events-none" />
      <div className="w-full max-w-md relative">
        <Link to="/" className="inline-flex items-center gap-1.5 mono text-[11px] uppercase tracking-widest text-white/60 hover:text-white mb-8">
          <ArrowLeft className="w-3 h-3" /> Späť na stránku
        </Link>
        <div className="bg-white border-2 border-ink-900 p-8 md:p-10">
          <div className="flex items-center gap-3 mb-8 pb-6 border-b-2 border-ink-900">
            <Logo size={52} />
            <div className="leading-tight">
              <div className="font-heading font-extrabold text-ink-900 text-lg">Administrácia</div>
              <div className="mono text-[11px] uppercase tracking-widest text-ink-500 mt-1">ObFZ Levice · Interný systém</div>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5" data-testid="admin-login-form">
            <div>
              <label className="label">Prihlasovacie meno</label>
              <div className="relative">
                <User className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-ink-400" />
                <input type="text" required value={username} onChange={(e) => setUsername(e.target.value)}
                       autoComplete="username"
                       className="input pl-9" placeholder="Zadajte prihlasovacie meno" data-testid="admin-username-input" />
              </div>
            </div>
            <div>
              <label className="label">Heslo</label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-ink-400" />
                <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                       autoComplete="current-password"
                       className="input pl-9" placeholder="••••••••" data-testid="admin-password-input" />
              </div>
            </div>

            {error && (
              <div className="bg-red-bg border-l-4 border-red text-red px-3 py-2 mono text-[11px] font-bold uppercase tracking-wider" data-testid="login-error">
                {error}
              </div>
            )}

            <button type="submit" disabled={submitting} className="btn btn-primary btn-lg w-full disabled:opacity-50" data-testid="admin-submit-btn">
              {submitting ? "Prihlasujem..." : "Prihlásiť sa"}
            </button>
          </form>
        </div>

        <div className="mt-6 mono text-[11px] uppercase tracking-widest text-white/50 text-center">
          ObFZ Levice · © {new Date().getFullYear()}
        </div>
      </div>
    </div>
  );
}
